import { Component, OnInit } from '@angular/core';

interface data {
  value: string;
  viewValue: string;
}
@Component({
  selector: 'app-ops-import',
  templateUrl: './ops-import.component.html',
  styleUrls: ['./ops-import.component.css']
})
export class OpsImportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  custs: data[] = [
    { value: 'FREEDOM-1', viewValue: 'FREEDOM' },
    { value: 'XOME-2', viewValue: 'XOME' },
    { value: 'PROTECK-3', viewValue: 'PROTECK' },
    { value: 'BK EMPOWER-4', viewValue: 'BK EMPOWER' },
    { value: 'FREEDOM XPANSE-5', viewValue: 'FREEDOM XPANSE' },
  ];

  fileType:data[]=[
    {value:'grrcn',viewValue:'GRRCN'},
    { value:'btcsv', viewValue:'BT CSV'},
    { value:'transSearchReport', viewValue:'Trans Search Report'}
  ]

  public ShowFilters: boolean = true;
  public buttonName: any = 'Show Filters';

  toggle() {
    this.ShowFilters = !this.ShowFilters;
    if (this.ShowFilters)
      this.buttonName = "Hide Filters";
    else
      this.buttonName = "Show Filters";
  }

}
